/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

let Custom = (function () {
    function isCartPage() {
        return window.location.pathname === '/cart' ||
            window.location.pathname.startsWith('/cart/');
    }

    function isProductPage()
    {
        return window.location.pathname.includes('/products/') &&
            document.querySelector('.product-form, [data-product-id]') !== null;
    }

    function formatMoney(price, currency) {
        // Mapowanie walut na locale
        const locales = {
            'PLN': 'pl-PL',
            'USD': 'en-US',
            'EUR': 'de-DE',
            'GBP': 'en-GB'
        };

        if(currency === undefined)
            currency = Shopify.currency.active;

        const locale = locales[currency] || 'en-US';

        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency
        }).format(price);
    }

    function initToolTips()
    {
        const tooltips = document.querySelectorAll('.info-tooltip-wrapper');

        tooltips.forEach(wrapper => {
            const btn = wrapper.querySelector('.info-tooltip-btn');
            const content = wrapper.querySelector('.tooltip-content');
            const closeBtn = wrapper.querySelector('.tooltip-close');

            btn.addEventListener('click', function(e) {
                e.stopPropagation();

                // Zamknij inne tooltipy
                document.querySelectorAll('.tooltip-content').forEach(tc => {
                    if (tc !== content) tc.style.display = 'none';
                });

                // Przełącz aktualny
                const isVisible = content.style.display === 'block';
                content.style.display = isVisible ? 'none' : 'block';
            });

            closeBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                content.style.display = 'none';
            });

            // Kliknięcie poza tooltip — zamyka wszystkie
            document.addEventListener('click', function() {
                content.style.display = 'none';
            });

            content.addEventListener('click', function(e) {
                e.stopPropagation();
            });
        });
    }

    function dispatchEvent(__element, __event)
    {
        let event = new Event(__event, { bubbles: true });
        __element.dispatchEvent(event);
    }

    function updateProductVariantId(__product_variant_id)
    {
        document.getElementsByName('id')[0].value = __product_variant_id;
    }


    function getShowContactFormButtons()
    {
        return document.querySelectorAll('.contact-form-toggle');
    }

    function initContactForm(__show_text, __hide_text)
    {
        const formful_section = findSectionWithFormfulBlock();
        if(formful_section)
        {
            formful_section.style.display = 'none';

            getShowContactFormButtons().forEach(function(__btn){
                __btn.addEventListener('click', function(e) {
                    e.preventDefault();
                    toggleElementVisibility({
                        btn: __btn,
                        elementId: formful_section.id
                    });
                });
            });

            document.querySelectorAll('.formful__button').forEach(function(__button){
                __button.classList.add("btn", "btn--neutral");
            });
        }


    }


    function findSectionWithFormfulBlock() {
        // Znajdź div z ID zawierającym "formful_app_block_form"
        const formfulDiv = document.querySelector('[id*="formful_app_block_form"]');

        if (!formfulDiv) {
            return null;
        }

        // Znajdź najbliższą sekcję Shopify
        const section = formfulDiv.closest('[id^="shopify-section-"]');

        return section;
    }

    function toggleElementVisibility(options) {
        const element = document.getElementById(options.elementId);
        const isHidden = element.style.display === 'none' ||
            window.getComputedStyle(element).display === 'none';

        if (isHidden) {
            element.style.display = 'block';
            element.offsetHeight; // wymusza reflow
            element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            getShowContactFormButtons().forEach(function(__btn){
                __btn.textContent = __btn.dataset.hideText;
            });
        } else {
            element.style.display = 'none';
            getShowContactFormButtons().forEach(function(__btn){
                __btn.textContent = __btn.dataset.showText;
            });
        }
    }

    function isElementVisible(__element)
    {
        var style = window.getComputedStyle(__element);
        return !(style.display === 'none');
    }

    function showElement(__element)
    {
        __element.style.display = 'inherit';
    }

    function hideElement(__element)
    {
        __element.style.display = 'none';
    }

    function hasInvalidElements(__div)
    {
        let invalid_divs = __div.querySelector('.error, .invalid, input:invalid');
        if(invalid_divs)
            return true;
        return false;
    }

    function initDropdowns()
    {

        document.querySelectorAll(".dropdown").forEach(function(dropdown){
            dropdown
                .querySelector('.dropdown-button')
                .onclick = function() {
                dropdown.classList.toggle('open');
            };

            // Zamknij dropdown po kliknięciu poza nim
            document.addEventListener('click', function(event) {
                if (!dropdown.contains(event.target)) {
                    dropdown.classList.remove('open');
                }
            });
        })

    }



    return {
        isCartPage: isCartPage,
        isProductPage: isProductPage,
        formatMoney: formatMoney,
        initToolTips: initToolTips,
        dispatchEvent: dispatchEvent,
        updateProductVariantId: updateProductVariantId,
        initContactForm: initContactForm,
        isElementVisible: isElementVisible,
        hideElement: hideElement,
        showElement: showElement,
        hasInvalidElements: hasInvalidElements,
        initDropdowns: initDropdowns,
    }
})();


(function() {
    // scroll position do searcha
    function adjustPopdownPosition() {
        const searchPopdown = document.querySelector('.search-popdown');
        const scrollPosition = window.scrollY;
        if (scrollPosition === 0) {
            if (window.innerWidth <= 767) {
                searchPopdown.style.top = "110px";
            } else {
                searchPopdown.style.top = "153px";
            }
        }else
        if (window.innerWidth <= 767) {
            searchPopdown.style.top = "68px";
        } else {
            searchPopdown.style.top = "110px";
        }
    }

    // wielkosc elementu menu 2 kratki ostatnie się nie rozwija
    function partnerBoxWidth(){
        const contact_width= document.querySelector('.header__desktop .menu__item.child').offsetWidth;
        const partner_width= document.querySelector('.header__desktop .menu__item.parent').offsetWidth;
        const partner_box_width = contact_width + partner_width + 23;

        document.documentElement.style.setProperty('--partner-box-width', `${partner_box_width}px`);
    }


    // Wywołaj funkcję przy scrollowaniu
    function handleScroll() {
        adjustPopdownPosition();
        partnerBoxWidth();
    }
    window.addEventListener('scroll', handleScroll);

    // Wywołaj funkcję przy załadowaniu strony
    function handleLoad() {
        adjustPopdownPosition();
        partnerBoxWidth();
    }
    window.addEventListener('load', handleLoad);

    // Wywołaj funkcję przy przeskalowaniu strony
    function handleResize() {
        adjustPopdownPosition();
        partnerBoxWidth();
    }
    window.addEventListener('resize', handleResize);


    document.addEventListener('DOMContentLoaded', function() {

        if(Custom.isProductPage())
        {
            ProductPage.init();
        }
        else
            Custom.initContactForm();

    });

})();

